// extracted by mini-css-extract-plugin
module.exports = {"tag":"ArticleTagItem_tag_1-fjK","link":"ArticleTagItem_link_2JQkk"};